import { render, staticRenderFns } from "./Accreditation.vue?vue&type=template&id=154665d0"
import script from "./Accreditation.vue?vue&type=script&lang=js"
export * from "./Accreditation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports